import { memo } from 'react';
import { useCoachesListHead, type CoachesListHeadPT } from '@widgets/coaches/coach-list-head/Model';
import { SBackButton, SSMagicBox } from '@widgets/coaches/coach-list-head/styles';
import { Search } from '@features/common/index';
import { ArrowIosLeft, FilterIcon } from '@shared/assets/icons';
import { SMagicBox } from '@shared/styles/styledComponentsCommon';
import { IconButton, PageHead } from '@shared/ui';
import { FilterMobileActions } from '@shared/ui/filter-mobile-actions/index.ts';

export const CoachListHead = memo(
  ({
    filterState,
    searchingState,
    resetAllParams,
    setSearchByName,
    searchByName,
  }: CoachesListHeadPT) => {
    const {
      specialistsNames,
      isClearFilterButtonDisabled,
      doIsSearchingOn,
      isFilterMobile,
      isSearchingMobile,
      doIsSearchingOff,
      changeFilterState,
      isSearching,
      setIsSearching,
      isFilterOpen,
      searchParams,
    } = useCoachesListHead({ filterState, searchingState, setSearchByName, searchByName });

    const filterMainButtonVariant =
      isFilterOpen || (searchParams.size !== 0 && !searchParams.has('searchByName'))
        ? 'activeDark'
        : 'dark';

    return (
      <PageHead
        Left={
          <SMagicBox $shouldHide={!isSearching}>
            <SBackButton
              variant="dark"
              onClick={() => {
                doIsSearchingOff();
                setSearchByName('');
              }}
            >
              <ArrowIosLeft />
            </SBackButton>
          </SMagicBox>
        }
        Right={
          <>
            <SSMagicBox
              $isSearching={isSearching}
              $shouldHideOnMobileL={isFilterOpen}
              onClick={() => {
                !isSearching && doIsSearchingOn();
              }}
            >
              {/*TODO: переписать это на норм компонент*/}
              {/*{isSearchingMobile ?*/}
              <Search
                placeholder="Поиск специалиста"
                shouldClose={!isSearching}
                mobile={isSearchingMobile}
                search={searchByName}
                onSearch={(name) => setSearchByName(name)}
                titles={specialistsNames}
                onClose={isSearchingMobile ? undefined : () => setIsSearching(false)}
              />
            </SSMagicBox>
            <SMagicBox $shouldHide={!isFilterMobile}>
              <FilterMobileActions
                isFilterActive={!isClearFilterButtonDisabled}
                onReset={resetAllParams}
                onConfirm={() => {
                  changeFilterState();
                }}
              />
            </SMagicBox>

            <SMagicBox $shouldHideOnMobileL={isSearching || isFilterMobile}>
              <IconButton
                onClick={() => {
                  isFilterOpen && resetAllParams();
                  changeFilterState();
                }}
                variant={filterMainButtonVariant}
              >
                <FilterIcon />
              </IconButton>
            </SMagicBox>
          </>
        }
      />
    );
  }
);
